import type { ReactNode } from 'react';

export const symbol_crossword: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M386-326v186h187v-186H386Zm-60-60v-187H140v187h186Zm60 0h187v-187H386v187Zm247 0h187v-187H633v187Zm0-247h187v-187H633v187ZM326-326H140q-24.75 0-42.37-17.63Q80-361.25 80-386v-187q0-24.75 17.63-42.38Q115.25-633 140-633h433v-187q0-24.75 17.63-42.38Q608.25-880 633-880h187q24.75 0 42.38 17.62Q880-844.75 880-820v434q0 24.75-17.62 42.37Q844.75-326 820-326H633v186q0 24.75-17.62 42.37Q597.75-80 573-80H386q-24.75 0-42.37-17.63Q326-115.25 326-140v-186Z"
		/>
	</svg>
);
